import styled from 'styled-components'

import { Text, theme, media, inputStyles } from '@redriverpress/system'

import OriginalField from 'Common/components/forms/Field'

export const Field = styled(OriginalField).attrs(() => ({
  height: '3.375rem',
  fontSize: [0, null, 2],
}))`
  border: ${props =>
    props.borderColor
      ? `1px solid ${theme.colors[props.borderColor]}`
      : 'none'};
  ${media.md`
    height: 3.8rem;
  `}
  ${media.sm`
    height: 3.375rem;
  `}
`

export const InputLabel = styled(Text).attrs(() => ({
  as: 'label',
  fontSize: 3,
  fontWeight: '600',
  marginBottom: 2,
}))``

export const CodeInput = styled.input`
  ${inputStyles}

  box-shadow: none;
  width: 100%;
  height: 3.75rem;
  line-height: 1.4;
  text-align: center;
  box-sizing: border-box;
  font-size: ${theme.fontSizes[4]};
  min-width: 0;
  border: ${props =>
    props.borderColor
      ? `2px solid ${theme.colors[props.borderColor]}`
      : 'none'};
`
